<div class="gold-background mt-5">
  <div *ngIf="!loginDisplay" class="container">
    <h2 class="pt-5 ms-3">Welcome To The User Admin Panel</h2>
  </div>
  <div *ngIf="loginDisplay" class="container">
    <div class="row">
      <div class="col">
        <h2 class="pt-5 ms-3">Welcome, {{ user?.name }}</h2>
      </div>
    </div>
    <div class="pt-3 line"></div>
    <div
      class="row pt-3 ms-3 justify-content-between row-cols-1 row-cols-sm-2 row-cols-md-4"
    >
      <div class="col">
        <span class="label">Selected Region</span><br />
        <span class="number">{{ region }}</span>
      </div>
      <div class="col">
        <span class="label">Registered Users</span><br />
        <app-count-up
          [isLoadingStats]="isLoadingStats"
          [isLoadingStatsErrorOccured]="isLoadingStatsErrorOccured"
          [number]="totalNumberOfUsers"
        ></app-count-up>
      </div>
      <div class="col">
        <span class="label">Active Users</span><br />
        <app-count-up
          [isLoadingStats]="isLoadingStats"
          [isLoadingStatsErrorOccured]="isLoadingStatsErrorOccured"
          [number]="usersStats?.activeUsers"
        ></app-count-up>
      </div>
      <div class="col">
        <span class="label">Inactive Users</span><br />
        <app-count-up
          [isLoadingStats]="isLoadingStats"
          [isLoadingStatsErrorOccured]="isLoadingStatsErrorOccured"
          [number]="usersStats?.inactiveUsers"
        ></app-count-up>
      </div>
    </div>
  </div>
</div>
<div class="grey-background">
  <div *ngIf="!loginDisplay" class="container landing-card">
    <app-landing></app-landing>
  </div>
  <div *ngIf="loginDisplay" class="container chart">
    <div class="row justify-content-between">
      <div class="col">
        <app-chart-bar-vertical
          [title]="'Total Registered Users Per Month'"
          [isLoadingStats]="isLoadingStats"
          [isLoadingStatsErrorOccured]="isLoadingStatsErrorOccured"
          [showYAxis]="showYAxis"
          [showXAxis]="showXAxis"
          [gradient]="gradient"
          [results]="registered"
          [colorScheme]="colorScheme"
          [view]="view"
        ></app-chart-bar-vertical>
      </div>
      <div class="col">
        <app-chart-bar-vertical
          [title]="'Total Deleted Users Per Month'"
          [isLoadingStats]="isLoadingStats"
          [isLoadingStatsErrorOccured]="isLoadingStatsErrorOccured"
          [showYAxis]="showYAxis"
          [showXAxis]="showXAxis"
          [gradient]="gradient"
          [results]="deleted"
          [colorScheme]="colorScheme"
          [view]="view"
        ></app-chart-bar-vertical>
      </div>
    </div>
    <div class="mt-5"></div>
  </div>
</div>
